import api from "./api";

function authHeaders() {
  const token = localStorage.getItem("tk446655440000");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * GET /Teacher/detail — structured teacher profile for the detail page.
 * @param {{ id?: string|number, regNumber?: string, historyLimit?: number, chartMonths?: number }} options
 */
export async function fetchTeacherDetail({
  id,
  regNumber,
  historyLimit = 50,
  chartMonths = 12,
} = {}) {
  const params = {};
  const numId = id != null && String(id).trim() !== "" ? String(id).trim() : "";
  const reg = regNumber != null && String(regNumber).trim() !== "" ? String(regNumber).trim() : "";

  if (numId) params.id = numId;
  else if (reg) params.regNumber = reg;
  else throw new Error("Teacher id or regNumber is required");

  if (historyLimit != null) params.historyLimit = Math.min(500, Math.max(1, Number(historyLimit) || 50));
  if (chartMonths != null) params.chartMonths = Math.min(36, Math.max(1, Number(chartMonths) || 12));

  const res = await api.get("/Teacher/detail", { params, headers: authHeaders() });
  return res.data;
}
